import { Component, OnInit, ViewChild } from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';
import { Router } from '@angular/router';
import { CouponService } from '../../services/coupon.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PatientService } from '../../services/patient.service';
import { menurolesService } from '../../services/menuroles.service';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { renderComponentOrTemplate } from '@angular/core/src/render3/instructions';
import { forEach } from '@angular/router/src/utils/collection';
import { SOMETHING_WENT_WRONG } from '../../appConstant';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
@Component({
  selector: 'app-patient-list',
  templateUrl: './patient-list.component.html',
  styleUrls: ['./patient-list.component.scss']
})
export class PatientListComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  p: number = 1;
  total: number;
  public patientList: any[];
  public countryCode: string;
  public setmobile: string;
  public homecountryCode: string;
  public sethome: string;
  public workcountryCode: string;
  public setwork: string;
  public patientChildList: any[];
  public statusMessage: string;
  public isViewPatients: boolean;
  public isViewPatientEdit: boolean;
  public isPageEditable: boolean;
  public isAddFamilyMember: boolean;
  public isEditFamilyMember: boolean;
  public pagetitle: string;
  public selectedUser: any;
  public formbuilder: any;
  public formSubmitAttempt: boolean;
  public patientId: string;
  public familyMemberId: string;
  EditForm: FormGroup;
  AddFamily: FormGroup;
  uploadForm: FormGroup;
  public selectedUserId: any;
  public uploadImageId: string;
  public userType: string;
  isSlide: boolean = false;
  todayDate: Date = new Date();
  maxDate = {};
  selectedImage: any;
  selectedImage2: any;
  userId: any;
  backImage: boolean = false;
  countyData: any;
  id: any = 0
  subCountyData: any;
  files = [];
  docValid: boolean = false;
  file: any;
  form_data = new FormData();
  userInsurancePolicies = [];
  familyInsurancePolicies = []


  constructor(private http: HttpClient, private _patientService: PatientService, private router: Router, private fb: FormBuilder, private _analyticsService: AnalyticsService, private _menurolesService: menurolesService) {
    this.pagetitle = "Patient List";
    this.isViewPatients = true;
    this.isViewPatientEdit = false;
    this.isAddFamilyMember = false;
    this.formbuilder = fb;

    const current = new Date();
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };


    this.uploadForm = this.fb.group({
      profile: ['']
    });
    this.EditForm = this.fb.group({
      patientFirstName: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.minLength(1)])],
      patientLastName: ['', [Validators.required, Validators.maxLength(19)]],
      email: ['', [
        Validators.required,
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$")
      ]],
      mobile: ['', [Validators.required, Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9+]+")]],
      nationalId: [],
      city: [],
      address: [],
      dob: ['', Validators.required],
      gender: [],
      employerInfo: [],
      insurerInfo: [],
      userName: [],
      referralCode: [],
      countryCode: []

    });
    this.AddFamily = this.fb.group({
      patientFirstName: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.minLength(1)])],
      patientLastName: ['', [Validators.required, Validators.maxLength(19)]],
      email: ['', [
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$")
      ]],
      mobile: ['', [Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9+]+")]],
      nationalId: [],
      city: [],
      address: [],
      employerInfo: [],
      insurerInfo: [],
      dob: ['', Validators.required],
      gender: [],
      countryCode: []
    });

  }

  ngOnInit() {
    this.pagetitle = "Patient List";
    this.isPageEditable = true;
    this.isViewPatients = true;
    this.isViewPatientEdit = false;
    this.isAddFamilyMember = false;
    let loginUser = JSON.parse(localStorage.getItem('currentUser'));

    const that = this;
    this.dtOptions = {
      "order": [[0, 'desc']],
      responsive: true,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters["token"] = loginUser.token;
        dataTablesParameters["userid"] = loginUser.userDetail.id;
        that.http
          .post<DataTablesResponse>(
            environment.apiURL + '/api/AdminPatientsList',
            dataTablesParameters, {}
          ).subscribe(resp => {
            console.log('type check ', typeof (resp.data));
            that.patientList = this.validateUsersProfileImages(resp.data);
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        { data: 'createdDate' },
        { data: 'profileImage', searchable: false, orderable: false },
        { data: 'patientName' },
        { data: 'gender' },
        { data: 'patientAge' },
        { data: 'mobile' },
        { data: 'email' },
        { data: 'cityName' }
      ]
    };
    this.getCountyAndSubCounty(this.id)
  }

  getCountyAndSubCounty(id) {
    console.log("selectionChangeselectionChange", id);

    if (id > 0) {
      this._patientService.getCountyAndSubCounty(id).subscribe(
        data => {
          let msg = data['response']
          this.subCountyData = this.getSubcounty(msg)
        },
        error => {
          alert(error)
          console.log(error)
        });
    } else {
      this._patientService.getCountyAndSubCounty(id).subscribe(
        data => {
          let msg = data['response']
          this.countyData = this.getCounty(msg)
        },
        error => {
          alert(error)
          console.log(error)
        });
    }

  }

  getCounty(data) {
    let finalCountylist = Object.keys(data).map((key, index) => {
      return {
        id: index + 1,
        name: key,
      };
    });
    return finalCountylist
  }

  getSubcounty(subcounty) {
    let finalSubcountyList = subcounty.map((item, index) => {
      return {
        id: index + 1,
        name: item.SUBCOUNTY,
      };
    });
    return finalSubcountyList
  }

  validateUsersProfileImages(users: any) {
    for (const user in users) {
      if (users[user].profileImage) {
        if (users[user].profileImage.includes("null") == true) {
          users[user].profileImage = '';
        }
      }
    }
    return users;
  }



  getPatientsList(page: number) {
    const perPage = 30;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    this.isViewPatients = true;
    this.isViewPatientEdit = false;
    this.isAddFamilyMember = false;
    this._analyticsService.getPatientsList(start, end)
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Patients does not exist..";
          }
          else {
            this.patientList = employeeData.response.patientList;
            this.total = parseInt(employeeData.count);
            this.p = page;
          }
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
  }

  viewChild(data) {
    debugger
    if (data.isViewChild) {
      data.isViewChild = false;
    }
    else {
      data.isViewChild = true;
    }
  }

  enableEditView(apt) {
   // debugger;
    this.pagetitle = "Edit Record";
    this.isViewPatients = false;
    this.isViewPatientEdit = true;
    this.isAddFamilyMember = false;
    this.selectedUser = apt;
    if (this.selectedUser) {
      this.patientId = apt.Id;
      this.countryCode = (apt.countryCode == '' || apt.countryCode == null) ? "254" : apt.countryCode;
      this.setmobile = (apt.mobile == null || apt.mobile == '') ? null : ("+" + ((apt.countryCode == '' || apt.countryCode == null) ? "254" : apt.countryCode) + apt.mobile);
      this.EditForm.controls['patientFirstName'].setValue(apt.patientFirstName);
      this.EditForm.controls['patientLastName'].setValue(apt.patientLastName);
      this.EditForm.controls['email'].setValue(apt.email);
      this.EditForm.controls['mobile'].setValue(this.setmobile);
      this.EditForm.controls['address'].setValue(apt.address);
      this.EditForm.controls['dob'].setValue(this.dateFormat(apt.patientDOB));
      this.EditForm.controls['gender'].setValue(apt.gender);
      this.EditForm.controls['employerInfo'].setValue(apt.employerInfo);
      this.EditForm.controls['insurerInfo'].setValue(apt.insurerInfo);
      this.EditForm.controls['userName'].setValue(apt.userName);
      this.EditForm.controls['city'].setValue(apt.cityName);
      this.EditForm.controls['referralCode'].setValue(apt.referralCode);
      this.EditForm.controls['nationalId'].setValue(apt.nationalId);
      if (apt.childList.length > 0) {
        console.log('apt.childList', apt.childList)
        this.getFamily(this.patientId);
      }
      else {
        this.patientChildList = [];
      }

    }
    else {
      this.router.navigate(['patientList']);
    }
    this._patientService.getUserInsurancePolicies(apt.Id).subscribe(
      data => {
        if (data.returnCode == 0) {
          this.userInsurancePolicies = data.response.policyList;
          console.log("user insurance policies",this.userInsurancePolicies)
        }
        else {
          this.userInsurancePolicies = [];
          console.log("no policies found")
          return {};
        }
      }
    )

  }


  onDocumentUploadFront(event) {

    if (event.target.files.length > 0) {

      var loginUser = JSON.parse(localStorage.getItem('currentUser'));
      // this.form_data.append('token', loginUser.token);
      // console.log("this.userId", loginUser.userDetail.id);

      // this.form_data.append('id', loginUser.userDetail.id)

      const reader = new FileReader();

      this.file = event.target.files[0];
      this.form_data.append('identityImage', this.file)
      reader.onload = () => {
        this.selectedImage = reader.result as string;
        this.files.push(this.selectedImage);
      }
      this.backImage = true
      reader.readAsDataURL(this.file);
    }
  }

  onDocumentUploadBack(event) {

    if (event.target.files.length > 0) {

      var loginUser = JSON.parse(localStorage.getItem('currentUser'));

      this.form_data.append('token', loginUser.token);
      this.form_data.append('id', loginUser.userDetail.id)


      const reader = new FileReader();

      this.file = event.target.files[0];
      this.form_data.append('profileImage', this.file, 'profileImage')
      reader.onload = () => {
        this.selectedImage2 = reader.result as string
        this.files.push(this.selectedImage2);
      }

      reader.readAsDataURL(this.file);
      console.log("this.form_data", this.form_data);

      this._patientService.compareRegistrationFaces(this.form_data).subscribe(
        data => {
          if (data.response.faceMatched) {
            let verifyPorfile = this.updatePatientaccount(this.patientId)
            console.log("verifyPorfile", verifyPorfile);
            alert("Verified sucessfully")
            this.docValid = true;
          } else {
            alert("Face not matched")
          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
  }

  updatePatientaccount(user) {
    console.log(user);
    this._patientService.updateAccountVerification(user).subscribe(
      data => {
        console.log("Updated sucessfully", data);
      },
      error => {
        alert(error)
        console.log(error)
      });
  }
  // onDocumentUpload(event, checkCondition) {

  //   if (event.target.files.length > 0) {

  //     var loginUser = JSON.parse(localStorage.getItem('currentUser'));
  //     var form_data = new FormData();
  //     form_data.append('token', loginUser.token);
  //     form_data.append('userId', this.userId);

  //     const reader = new FileReader();

  //     if (this.backImage || checkCondition == 'backImage') {
  //       this.file = event.target.files[0];
  //       form_data.append('profileImage', this.file, 'profileImage')
  //       reader.onload = () => {
  //         this.selectedImage2 = reader.result as string
  //         // console.log("this.selectedImage2", this.selectedImage2);
  //         this.files.push(this.selectedImage2);
  //       }
  //     } else {
  //       this.file = event.target.files[0];
  //       form_data.append('identityImage', this.file)
  //       reader.onload = () => {
  //         this.selectedImage = reader.result as string;
  //         this.files.push(this.selectedImage);
  //       }
  //       this.backImage = true
  //     }

  //     reader.readAsDataURL(this.file);
  //     if (checkCondition == 'backImage') {
  //       this._patientService.compareRegistrationFaces(form_data).subscribe(
  //         data => {
  //           console.log("dataaaaa", data)
  //         },
  //         error => {         
  //           alert(error)
  //           console.log(error)
  //         });

  //     }
  //   }
  // }


  displayAddFamilyMemberForm() {
    this.isAddFamilyMember = true;
    this.familyMemberId = '';
    this.pagetitle = "Add Family Member ";
  }

  reset() {
    this.pagetitle = "Patient List";
    this.isViewPatients = true;
    this.isViewPatientEdit = false;
  }

  cancelAddFamilyMember() {
    this.isAddFamilyMember = false;
    this.pagetitle = "Edit Record";
    this.AddFamily.reset();
  }


  updaterecords(EditForm) {

    this.formSubmitAttempt = true;
    // if (EditForm.invalid) {
    //   return;
    // } else {


    // this.validateDocument()
    // if (this.docValid) {
      console.log("docValid", this.docValid);
      EditForm.value.id = this.patientId;
      EditForm.value.childList = this.patientChildList;
      EditForm.value.firstname = EditForm.value.patientFirstName;
      var loginUser = JSON.parse(localStorage.getItem('currentUser'));
      let dob = null;
      if (EditForm.value.dob) {
        dob = EditForm.value.dob.month + '/' + EditForm.value.dob.day + '/' + EditForm.value.dob.year
      }

      let formdata = {
        "firstname": EditForm.value.patientFirstName,
        "lastname": EditForm.value.patientLastName,
        "email": EditForm.value.email,
        "mobile": (EditForm.value.mobile == null || EditForm.value.mobile == "") ? null : (EditForm.value.mobile.indexOf("+" + this.countryCode) > -1) ? EditForm.value.mobile.split("+" + this.countryCode)[1] : EditForm.value.mobile,
        "gender": EditForm.value.gender === 'Male' ? 0 : 1,
        "countrycode": this.countryCode,
        "dob": dob,
        "employerinfo": EditForm.value.employerInfo,
        "insurerinfo": EditForm.value.insurerInfo,
        "username": EditForm.value.userName,
        "nationalId": EditForm.value.nationalId,
        "referralCode": EditForm.value.referralCode,
        "city": EditForm.value.city,
        "address": EditForm.value.address,
        "userid": this.patientId,
        "token": loginUser.token,

      }
      console.log('formdata', formdata);
      // Update Patient API......

      this._patientService.updatePatient(formdata).subscribe(
        data => {
          if (data.returnCode == 0) {
            console.log("this.form_data", this.form_data);

            this, this._patientService.uploadIDphoto(this.form_data, this.patientId).subscribe(data => {
              console.log("upload image data", data)
            })
            this.formSubmitAttempt = false;
            alert("Patient details updated Sucessfully")
            // this.router.navigate(['patientList']);
            this.reset();
          }
          else {
            alert(data.returnMsg)
          }
        },
        error => {
          alert(error)
          console.log(error)
        });

    // } else {
    //   alert("Documents are not valid")
    // }







  }


  saveFamily(AddFamily) {
    this.formSubmitAttempt = true;
    let formdata = AddFamily.value;
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    if (AddFamily.invalid) {
      return;
    } else {

      let dob = null;
      if (AddFamily.value.dob) {
        dob = AddFamily.value.dob.month + '/' + AddFamily.value.dob.day + '/' + AddFamily.value.dob.year
      }
      if (this.familyMemberId) {

        let family = {
          "firstname": AddFamily.value.patientFirstName,
          "lastname": AddFamily.value.patientLastName,
          "email": AddFamily.value.email,
          "mobile": (AddFamily.value.mobile == null || AddFamily.value.mobile == "") ? null : (AddFamily.value.mobile.indexOf("+" + this.countryCode) > -1) ? AddFamily.value.mobile.split("+" + this.countryCode)[1] : AddFamily.value.mobile,
          "gender": AddFamily.value.gender === 'Male' ? 0 : 1,
          "countrycode": this.countryCode,
          "dob": dob,
          "employerinfo": AddFamily.value.employerInfo,
          "insurerinfo": AddFamily.value.insurerInfo,
          "nationalId": AddFamily.value.nationalId,
          "city": AddFamily.value.city,
          "address": AddFamily.value.address,
          "userid": this.familyMemberId,
          "token": loginUser.token
        };
        this._patientService.updateFamilyMember(family).subscribe(
          data => {
            if (data.returnCode == 0) {
              this.formSubmitAttempt = false;
              alert("Family member details updated sucessfully.")
              // Get all family member of patient
              this.getFamily(this.patientId);
            }
            else {
              alert(data.returnMsg)
            }
          },
          error => {
            alert(error)
            console.log(error)
          });

      } else {
        let family = {
          "firstname": AddFamily.value.patientFirstName,
          "lastname": AddFamily.value.patientLastName,
          "email": AddFamily.value.email,
          "mobile": (AddFamily.value.mobile == null || AddFamily.value.mobile == "") ? null : (AddFamily.value.mobile.indexOf("+" + this.countryCode) > -1) ? AddFamily.value.mobile.split("+" + this.countryCode)[1] : AddFamily.value.mobile,
          "gender": AddFamily.value.gender === 'Male' ? 0 : 1,
          "countrycode": this.countryCode,
          "dob": dob,
          "employerinfo": AddFamily.value.employerInfo,
          "insurerinfo": AddFamily.value.insurerInfo,
          "nationalId": AddFamily.value.nationalId,
          "city": AddFamily.value.city,
          "address": AddFamily.value.address,
          "userid": this.patientId,
          "token": loginUser.token
        };
        // Save Patient Member API ......
        this._patientService.savePatientFamily(family).subscribe(
          data => {
            if (data.returnCode == 0) {
              this.formSubmitAttempt = false;
              alert("Family member added Sucessfully")
              // Get all family member of patient
              this.getFamily(this.patientId);
            }
            else {
              alert(data.returnMsg)
            }
          },
          error => {
            alert(error)
            console.log(error)
          });
      }

      this.cancelAddFamilyMember();
    }

  }

 

  getFamily(patientId) {
    this.patientChildList = [];
    this._patientService.getFamily(patientId).subscribe(
      data => {
        if (data.returnCode == 0) {
          let childs = data.response.familyMembers.map(child => {
            return {
              'Id': child.id,
              'profileImage': child.profileImage,
              'patientFirstName': child.firstName,
              'patientLastName': child.lastName,
              'patientName': child.name,
              'patientAge': child.age,
              'patientDOB': child.dateOfBirth,
              'nationalId': child.nationalid,
              'gender': child.gender,
              'createdDate': child.createdDate
            };
          })
          this.patientChildList = childs;
        }
        else {
          return {};
        }
      },
      error => {
        alert(error)
        console.log(error)
      });
  }


  editFamilyMember(member) {
    //debugger;
    this.familyMemberId = member.Id;
    this.isEditFamilyMember = true;
    this.pagetitle = "Edit Family Member ";
    this.countryCode = (member.countryCode == '' || member.countryCode == null) ? "254" : member.countryCode;
    this.setmobile = (member.mobile == null || member.mobile == '') ? null : ("+" + ((member.countryCode == '' || member.countryCode == null) ? "254" : member.countryCode) + member.mobile);
    this.AddFamily.controls['patientFirstName'].setValue(member.patientFirstName);
    this.AddFamily.controls['patientLastName'].setValue(member.patientLastName);
    this.AddFamily.controls['email'].setValue(member.email);
    this.AddFamily.controls['mobile'].setValue(this.setmobile);
    this.AddFamily.controls['dob'].setValue(this.dateFormat(member.patientDOB));
    this.AddFamily.controls['gender'].setValue(member.gender == '0' ? 'Male' : 'Female');
    this.AddFamily.controls['address'].setValue(member.address);
    this.AddFamily.controls['employerInfo'].setValue(member.employerInfo);
    this.AddFamily.controls['insurerInfo'].setValue(member.insurerInfo);
    this.AddFamily.controls['city'].setValue(member.cityName);
    this.AddFamily.controls['nationalId'].setValue(member.nationalId);
    this.AddFamily.controls['countryCode'].setValue(member.countryCode);
    this.isAddFamilyMember = true;
    
    this._patientService.getUserInsurancePolicies(member.Id).subscribe(
      data => {
        if (data.returnCode == 0) {
          this.familyInsurancePolicies = data.response.policyList;
          console.log("family insurance policies",this.familyInsurancePolicies)
        }
        else {
          this.familyInsurancePolicies = [];

          return {};
        }
      }
    )
  }

  deleteInsurancePolicy(policy) {
    let confirmation = confirm("Are you sure want to Delete '" + policy.insuranceName + "'");
    if(confirmation){
      this._patientService.deactivateInsurancePolicy(policy.id).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record Deleted sucessfully")
           // this.isEditFamilyMember = false;
            this.reset();
            // this.getFamily(this.patientId);
            // this._patientService.getUserInsurancePolicies(this.patientId).subscribe(
            //   data => {
            //     if (data.returnCode == 0) {
            //       this.familyInsurancePolicies = data.response.policyList;
            //       this.userInsurancePolicies = data.response.policyList;
            //       // console.log("family insurance policies",this.familyInsurancePolicies)
            //     }
            //     else {
            //       this.familyInsurancePolicies = [];
  
            //       return {};
            //     }
            //   }
            // )

          }
          else {
            alert(SOMETHING_WENT_WRONG)
          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
  }
  deleteFamilyMember(member) {
    let index = this.patientChildList.map(function (o) { return o.Id; }).indexOf(member.Id);
    let confimationMessage = "Are you sure want to Delete '" + member.patientName + "'";
    if (confirm(confimationMessage)) {
      // Delete Family Member API......
      this._patientService.deletePatient(member).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record Deleted sucessfully")
            this.patientChildList.splice(index, 1);
            //this.getFamilyMember();
          }
          else {
            alert(data.returnMsg)
          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }


  }

  deletePatient(patient) {
    let confimationMessage = "Are you sure want to Delete '" + patient.patientFirstName + ' ' + patient.patientLastName + "'";
    if (confirm(confimationMessage)) {
      // Delete Family Member API......
      this._patientService.deletePatient(patient).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record Deleted sucessfully")
            this.getPatientsList(1);
          }
          else {
            alert(data.returnMsg)
          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
  }

  telInputObject(obj: any) {
    console.log(obj);
    obj.intlTelInput('setCountry', 'ke');
  }


  dateFormat(date) {
    const d = new Date(date);
    if (date) {
      date = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    }
    else {
      date = {};
    }
    return date;
  }

  openFileUploader(Id, userType) {
   // debugger
    this.uploadImageId = Id;
    this.userType = userType
    let element: HTMLElement = document.querySelector('input[type="file"]') as HTMLElement;
    element.click();
  }




  uploadImage($event) {
   // debugger
    const files = $event.target.files || $event.srcElement.files;
    this.uploadForm.get('profile').setValue(files[0]);
    const file = files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('file', this.uploadForm.get('profile').value);
    this._patientService.uploadImage(this.uploadForm.get('profile').value, this.uploadImageId)
      .subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Image update sucessfully");
            console.log('data', data)
            //window.location.reload();
          }
          else {
            alert(data.returnMsg)
          }
        },
        error => {
          alert(error)
          console.log(error)
        });
  }



  onCountryChange(obj: any) {
    var oldcountry = this.countryCode
    this.countryCode = obj.dialCode
    this.setmobile = (this.EditForm.value.mobile == null || this.EditForm.value.mobile == "") ? null : (this.EditForm.value.mobile.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.mobile.split("+" + oldcountry)[1] : this.EditForm.value.mobile;
    if (this.setmobile) {
      this.EditForm.controls['mobile'].setValue("+" + obj.dialCode + this.setmobile);
    }
  }

  onMobileTextChange(event: any) {
    var oldcountry = this.homecountryCode;
    this.setmobile = (this.EditForm.value.mobile == null || this.EditForm.value.mobile == "") ? null : (this.EditForm.value.mobile.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.mobile.split("+" + oldcountry)[1] : this.EditForm.value.mobile;
    if (this.setmobile) {
      this.EditForm.controls['mobile'].setValue("+" + this.homecountryCode + this.setmobile);
    }
  };

  onHomeCountryChange(obj: any) {

    var oldcountry = this.countryCode
    this.homecountryCode = obj.dialCode
    this.sethome = (this.EditForm.value.home == null || this.EditForm.value.home == "") ? null : (this.EditForm.value.home.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.home.split("+" + oldcountry)[1] : this.EditForm.value.home;
    if (this.sethome) {
      this.EditForm.controls['home'].setValue("+" + obj.dialCode + this.sethome);
    }
  }

  onHomeTextChange(event: any) {
    var oldcountry = this.homecountryCode;
    this.sethome = (this.EditForm.value.home == null || this.EditForm.value.home == "") ? null : (this.EditForm.value.home.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.home.split("+" + oldcountry)[1] : this.EditForm.value.home;
    if (this.sethome) {
      this.EditForm.controls['home'].setValue("+" + this.homecountryCode + this.sethome);
    }
  };

  onWorkCountryChange(obj: any) {
    var oldcountry = this.countryCode
    this.workcountryCode = obj.dialCode
    this.setwork = (this.EditForm.value.work == null || this.EditForm.value.work == "") ? null : (this.EditForm.value.work.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.work.split("+" + oldcountry)[1] : this.EditForm.value.work;
    if (this.setwork) {
      this.EditForm.controls['work'].setValue("+" + obj.dialCode + this.setwork);
    }
  }

  onWorkTextChange(event: any) {
    var oldcountry = this.homecountryCode;
    this.setwork = (this.EditForm.value.work == null || this.EditForm.value.work == "") ? null : (this.EditForm.value.work.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.work.split("+" + oldcountry)[1] : this.EditForm.value.work;
    if (this.setwork) {
      this.EditForm.controls['work'].setValue("+" + this.homecountryCode + this.setwork);
    }
  };

  getNumber(obj: any) {
    console.log(obj);
  }


  hasError(obj: any) {
    console.log(obj)
  }

  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }


  }


  onSearchChange(searchValue: string) {

    //this.reports = this.reports.filter(t=>t.patientName == searchValue)
    // this._analyticsService.searchPatients(searchValue)
    this._analyticsService.getPatientsList()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Patients does not exist..";
          }
          else {
            this.patientList = employeeData.response.patientList.filter(t => {
              let patientName = (t.patientName != null && t.patientName.toLowerCase().indexOf(searchValue.toLowerCase()) > -1);
              let gender = (t.gender != null && t.gender.toLowerCase() == searchValue.toLowerCase());
              let cityName = (t.cityName != null && t.cityName.toLowerCase() == searchValue.toLowerCase());
              let email = (t.email != null && t.email.toLowerCase().indexOf(searchValue.toLowerCase()) > -1)
              let mobile = (t.mobile != null && t.mobile.toLowerCase().indexOf(searchValue.toLowerCase()) > -1);

              if (patientName || gender || cityName || email || mobile) {
                return t;
              }
            })
          }
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );

  }
  trackTask(index: number, item): string {
    return `${item.id}`;
  }


  openBookAppointments(patient: any) {
    console.log('selected patient ', patient);
    if (!patient.email) {
      patient.email = '';
    }
    if (!patient.mobile) {
      patient.mobile = '';
    }
    this.router.navigate(['/bookAppointment', { id: patient.Id, name: patient.patientName, email: patient.email, mobile: patient.mobile, appointmentPage: "0" }]);
  }

  viewAppointments(patient: any) {
    console.log('selected patient ', patient);
    if (!patient.email) {
      patient.email = '';
    }
    if (!patient.mobile) {
      patient.mobile = '';
    }
    this.router.navigate(['/bookAppointment', { id: patient.Id, name: patient.patientName, email: patient.email, mobile: patient.mobile, appointmentPage: "1" }]);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/patient-list/patient-list.component.ts